(function () {
  'use strict';

  var SELECTORS = {
    productGrid:
      'results-list, .collection-wrapper, .predictive-search-results__products, .predictive-search-results, predictive-search, #ResultsList, main, product-recommendations, .product-recommendations, header-component, .header-section',
    wishlistButton: '.twp-product-card__wishlist',
  };

  var wishlistedSet = {};

  function initCollectionButtons(swat) {
    var helpers = window.SwymWishlistHelpers;
    if (!helpers) return;

    swat.fetch(function (wishlisted) {
      wishlistedSet = {};
      wishlisted.forEach(function (item) {
        wishlistedSet[Number(item.empi)] = true;
      });
      wireButtons(swat, helpers);
      observeGrid(swat, helpers);
    });
  }

  function buildProductFromButton(helpers, btn) {
    var empi = Number(btn.getAttribute('data-product-id'));
    var epi = Number(btn.getAttribute('data-variant-id'));
    var productUrl = btn.getAttribute('data-product-url');

    return {
      empi: empi,
      epi: epi,
      du: helpers.toAbsoluteDu(productUrl),
      dt: btn.getAttribute('data-product-title') || '',
      iu: btn.getAttribute('data-product-image') || '',
      pr: Number(btn.getAttribute('data-product-price')) || 0,
    };
  }

  function resolveCardProduct(swat, helpers, btn, callback) {
    var handle = btn.getAttribute('data-product-handle');
    var productUrl = btn.getAttribute('data-product-url');
    var productPath = handle ? '/products/' + handle : helpers.toProductPath(productUrl);

    if (!productPath) return;

    helpers.resolveProduct(
      swat,
      {
        productPath: productPath,
        productUrl: productUrl,
        handle: handle,
      },
      callback
    );
  }

  function toggleWishlist(swat, helpers, btn, product) {
    var source = helpers.getWishlistSource(btn);

    if (btn.classList.contains('swym-added')) {
      helpers.removeProduct(
        swat,
        product.empi,
        function () {
          btn.classList.remove('swym-added');
          btn.setAttribute('aria-label', 'Add to wishlist');
          delete wishlistedSet[Number(product.empi)];
          helpers.notifyChange(swat, -1);
        },
        function () {
          /* keep current state on error */
        },
        source
      );
    } else {
      swat.addToWishList(
        helpers.withSource(product, source),
        function () {
          btn.classList.add('swym-added');
          btn.setAttribute('aria-label', 'Remove from wishlist');
          wishlistedSet[Number(product.empi)] = true;
          helpers.notifyChange(swat, 1);
        },
        function () {
          /* keep current state on error */
        }
      );
    }
  }

  function wireButtons(swat, helpers) {
    document.querySelectorAll(SELECTORS.wishlistButton + ':not([data-swym-wired])').forEach(function (btn) {
      btn.setAttribute('data-swym-wired', 'true');

      var productId = Number(btn.getAttribute('data-product-id')) || 0;

      if (productId && wishlistedSet[productId]) {
        btn.classList.add('swym-added');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = Number(btn.getAttribute('data-variant-id'));

        if (!variantId) {
          resolveCardProduct(swat, helpers, btn, function (product) {
            if (!product || !product.epi || !product.empi) return;
            toggleWishlist(swat, helpers, btn, product);
          });
          return;
        }

        var product = buildProductFromButton(helpers, btn);

        if (!product.empi || !product.epi || product.epi === product.empi) {
          console.warn('[Swym Wishlist] Invalid product data on wishlist button:', product);
          return;
        }

        toggleWishlist(swat, helpers, btn, product);
      });
    });
  }

  function observeGrid(swat, helpers) {
    var grids = document.querySelectorAll(SELECTORS.productGrid);
    if (!grids.length) return;

    var observer = new MutationObserver(function () {
      wireButtons(swat, helpers);
    });

    grids.forEach(function (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initCollectionButtons);
})();
